import { render, staticRenderFns } from "./Scopes.vue?vue&type=template&id=142bc1a7"
import script from "./Scopes.vue?vue&type=script&lang=js"
export * from "./Scopes.vue?vue&type=script&lang=js"
import style0 from "./Scopes.vue?vue&type=style&index=0&id=142bc1a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports